export enum DiscountConstants {
    CC = "CC",
    RC = "RC",
    SF = "SF"
}
